import { I18n } from '@calendly/i18n'

import { useEventType } from 'features/event_type_provider'
import { useTrack } from 'hooks/analytics_events'
import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events/constants'

import { Summary } from './summary'
import { AccordionPanel } from '../../../components/accordion'
import { Payment } from '../../components/payment'


export const PaymentPanel = ({ isLocked, trackingSection = 'more_options_page', ...props }) => {
  const track = useTrack()
  const { uuid } = useEventType()

  return (
    <AccordionPanel
      titleId="payment-label"
      title={I18n.t('publisher.event_type_editor.sections.more_options.payment.title')}
      subheader={<Summary isLocked={isLocked} showIcon={trackingSection !== 'initial_editor_page'} />}
      {...props}
      onSelected={(...args) => {
        props.onSelected(...args)
        if (!props.expand) {
          track({
            name: TRACKING_EVENT_NAMES.EVENT_TYPE_EDITOR_INTERACTION,
            properties: {
              event_type_uuid: uuid,
              section: trackingSection,
              action: 'open_payments_section',
            }
          })
        }
      }}
    >
      <Payment isLocked={isLocked} />
    </AccordionPanel>
  )
}
